import { FileResponse } from "../services/api-services";
import MimeTypeHelper from "./mime-type.helper";

export default class DownloadHelper {
  public static downloadFile(data: FileResponse | null): void {
    const blob: any = new Blob([data?.data!], { type: `${data?.fileName!}; charset=utf-8` });

    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute('download', data?.fileName!);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  public static openFileInNewTab(data: FileResponse | null): void {
    const blob: any = new Blob([data?.data!], { type: MimeTypeHelper.getMimeTypeFromFileName(data?.fileName!) });

    const blobUrl = window.URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  }
}
